import React, { useState, useEffect, useContext } from 'react';
import { ILucky, IUserLuckyOne } from '../../store/LuckyStore';
import { inject, observer } from 'mobx-react';
import RootStore from '../../store/RootStore';
import TypePan from './TypePan';
import moment from 'moment';
import intl from 'react-intl-universal';
import { fixedLength } from '../../utils/util';

export interface ILuckyProps {
  cid: string;
  data: ILucky;
  rootStore?: RootStore;
  show_result: boolean;
  mode: string;
  onLucky: () => PromiseLike<any> | boolean;
  onShowPhone?: () => void;
  onShowAllLuck?: () => void;
  onShowMyLuck?: () => void;
}

export const LEVEL_TITLE = {
  '1': '一等奖',
  '2': '二等奖',
  '3': '三等奖',
  '4': '四等奖',
  '5': '五等奖',
  '6': '六等奖',
  '7': '七等奖'
} as {
  [key: string]: string;
};

export const getTimeline = (begin_at: string, end_at: string) => {
  let status = 'wait';
  let timeline = [] as string[];
  let now = moment();
  if (now.isBefore(begin_at)) {
    // 未开始
    status = 'wait';
    let duration = moment.duration(moment(begin_at).valueOf() - now.valueOf());
    timeline = [
      fixedLength(duration.days()),
      intl.get('Day'),
      fixedLength(duration.hours()),
      intl.get('Hour'),
      fixedLength(duration.minutes()),
      intl.get('Minute'),
      fixedLength(duration.seconds()),
      intl.get('Second')
    ];
  } else if (now.isAfter(end_at)) {
    // 已结束
    status = 'stop';
  } else if (now.isAfter(begin_at) && now.isBefore(end_at)) {
    status = 'start';
  }

  return [status, timeline];
};

const Lucky = (props: ILuckyProps) => {
  const { data } = props;

  const renderType = () => {
    if (data) {
      const { type } = data;
      if (type == 'pan') {
        return <TypePan {...props} key={type} />;
      }
    }
  };

  return <div className="lucky">{renderType()}</div>;
};

export default inject('rootStore')(observer(Lucky));
